module.exports = __webpack_public_path__ + "media/images/matching_double_sp-456b1a60a728259819174f7c327e3e22.png";